import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts-6/core'
import {
    BarChart,
    LineChart,
    CustomChart,
    ScatterChart,
    CandlestickChart,
} from 'echarts-6/charts'
import {
    GridComponent,
    // PolarComponent,
    // RadarComponent,
    // GeoComponent,
    // SingleAxisComponent,
    // ParallelComponent,
    // CalendarComponent,
    // GraphicComponent,
    ToolboxComponent,
    TooltipComponent,
    AxisPointerComponent,
    // BrushComponent,
    TitleComponent,
    // TimelineComponent,
    // MarkPointComponent,
    // MarkLineComponent,
    MarkAreaComponent,
    // LegendComponent,
    // LegendScrollComponent,
    // LegendPlainComponent,
    // DataZoomComponent,
    // DataZoomInsideComponent,
    // DataZoomSliderComponent,
    // VisualMapComponent,
    // VisualMapContinuousComponent,
    // VisualMapPiecewiseComponent,
    // AriaComponent,
    // TransformComponent,
    // DatasetComponent,
    LegendComponent,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
    MarkLineComponent,
} from 'echarts-6/components'
import { CanvasRenderer } from 'echarts-6/renderers'

echarts.use([
    BarChart,
    LineChart,
    CustomChart,
    ScatterChart,
    CandlestickChart,
    GridComponent,
    TooltipComponent,
    TitleComponent,
    LegendComponent,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
    ToolboxComponent,
    AxisPointerComponent,
    MarkAreaComponent,
    MarkLineComponent,
    CanvasRenderer],
    // SVGRenderer,
)

const EChartV6Pluvio = ({
    option,
    lazyUpdate = true,
    notMerge = true,
    style,
    className,
    onEvents,
    onChartReady,
}) => {
    const chartRef = useRef(null)

    useEffect(() => {
        const handleResize = () => {
            const instance = chartRef.current?.getEchartsInstance()
            if (instance && !instance.isDisposed()) {
                instance.resize()
            }
        }
        window.addEventListener('resize', handleResize)
        const timeoutId = setTimeout(handleResize, 300)
        return () => {
            window.removeEventListener('resize', handleResize)
            clearTimeout(timeoutId)
        }
    }, [])

    return (
        <ReactEChartsCore
            ref={chartRef}
            echarts={echarts}
            option={option}
            notMerge={notMerge}
            lazyUpdate={lazyUpdate}
            style={style}
            className={className}
            onEvents={onEvents}
            onChartReady={onChartReady}
        />
    )
}

EChartV6Pluvio.propTypes = {
    option: PropTypes.shape({}).isRequired,
    lazyUpdate: PropTypes.bool,
    notMerge: PropTypes.bool,
    style: PropTypes.shape({}),
    className: PropTypes.string,
    onEvents: PropTypes.shape({}),
    onChartReady: PropTypes.func,
}

export default EChartV6Pluvio
